const Api = "https://middleware.urbieta.eu/api";
//const Api = process.env.REACT_APP_API_URL;
const filtrosProveedor = {
  Nombre: "",
  NIF: "",
  Provincia: "",
};

const filtrosAlmacen = {
  Nombre: "",
};

const filtrosEstados = {
  Nombre: "",
};
const filtrosRsiduos = {
  Nombre: "",
  Ler: "",
};

const filtrosAlbaran = {
  Proveedor: "",
};

const filtrosPrecioResiduo = {
  res_ler: "",
  res_nombre: "",
};

export default {
  Api,
  filtrosProveedor,
  filtrosAlmacen,
  filtrosEstados,
  filtrosRsiduos,
  filtrosAlbaran,
  filtrosPrecioResiduo,
};
